import { getFollowedTopics } from '../api/users'
import type { Topic } from '../types/topic'

export const useTopics = () => useState<Topic[]>('topics', () => [])
export const useFollowedTopicsLoaded = () => useState<boolean>('followedTopicsLoaded', () => false)

export const useFollowedTopics = () => useState<number[]>('followed-topics', () => [])

export const loadFollowedTopics = async () => {
  const user = useUser()

  if (!user.value)
    return

  const followedTopics = useFollowedTopics()

  const resp = await getFollowedTopics(user.value.id).then(topics => topics).catch(() => null)

  if (!resp)
    return

  followedTopics.value = resp
}
